import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "react-responsive";
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import Progress from "../../../../ui/Progress";
import Tabs from "../../../../ui/Tabs";
import Box from "../../../../ui/Box";
import TopBar from "./components/TopBar";
import ProgramInfoDrawer from "../../../../ManageOOP/Resources/OpMod/MyOPMod/components/ProgramInfoDrawer";
import {withRouter} from "react-router-dom";
import { getFullProgram, getProgram } from "../../../../ManageOOP/Resources/OpMod/MyOPMod/store/actions";
import {changeProgramInfoAction,
  clearProgramCreatedAction,
  updateConstructorProgram,
  sendProgramToExpertise,
  sendProgramToPublication,
  sendProgramToDevelop,
  approveProgramExpertise,
  approveProgramPublication,
  rejectProgramExpertise,
  rejectProgramPublication
} from "../../store/send";
import ProgramMainInfoEdit from "./components/ProgramMainInfoEdit";
import ProgramModulesEdit from "./components/ProgramModulesEdit";
import ProgramFiles from "./components/ProgramFiles";
import ApproveModal from "./components/ApproveModal";
import Typography from "@material-ui/core/Typography";
import Alert from '@material-ui/lab/Alert';
import Authors from "./components/Authors";

const useStyles = makeStyles(() => ({
  mainRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  }
}));

const items = [
  { label: "Конструктор КиОП", link: "/work/app/constructor" },
  { label: "Конструктор образовательных программ", link: "/work/app/constructor/programs" }
];

const tabitems = [
  { number: 0, caption: "Основные сведения" },
  { number: 2, caption: "Модули" },
  { number: 3, caption: "Файлы" }
];

const ProgramEdit = ({match, history,
                       getProgram,
                       getFullProgram,
                       programFullInfo,
                       changeProgramInfoAction,
                       clearProgramCreatedAction,
                       programInfo,
                       updateConstructorProgram,
                       isUpdatingProgram,
                       sendProgramToExpertise,
                       sendProgramToPublication,
                       sendProgramToDevelop,
                       approveProgramExpertise,
                       approveProgramPublication,
                       rejectProgramExpertise,
                       rejectProgramPublication
}) => {
  const { id } = match.params;
  const classes = useStyles();

  const [saveProgram, setSaveProgram] = useState(false);
  const [expertiseModalOpen, setExpertiseModalOpen] = useState(false);
  const [approveExpertiseModalOpen, setApproveExpertiseModalOpen] = useState(false);
  const [rejectExpertiseModalOpen, setRejectExpertiseModalOpen] = useState(false);
  const [developModalOpen, setDevelopModalOpen] = useState(false);
  const [publicationModalOpen, setPublicationModalOpen] = useState(false);
  const [approvePublicationModalOpen, setApprovePublicationModalOpen] = useState(false);
  const [rejectPublicationModalOpen, setRejectPublicationModalOpen] = useState(false);

  const returnBack = () => history.push("/work/app/constructor/programs");
  const isLarge = useMediaQuery({ minWidth: 1024 });
  const isSmall = useMediaQuery({ maxWidth: 774 });

  const handleReload = () => {
    getFullProgram(id);
    getProgram(id);
  }

  const saveProgramHandler = async () => {
    const program = {
      main: programInfo
    };
    //console.log(program);
    setSaveProgram(true);

    await updateConstructorProgram(id, program);
    await getProgram(id);
  };

  useEffect(() => {
    getFullProgram(id);
    clearProgramCreatedAction();
  }, []);

  return(
    <div>
      <Breadcrumbs items={items} />
      {programFullInfo ? (
      <div className={classes.mainRoot}>
        <ApproveModal open={expertiseModalOpen} programId={id}
                      handleClose={() => setExpertiseModalOpen(false)}
                      handleConfirm={sendProgramToExpertise}
                      reload={handleReload}
                      isLoading={isUpdatingProgram}
                      message="После отправки на экспертизу редактирование будет невозможно."
                      modalText="Отправить программу на экспертизу?"/>
        <ApproveModal open={developModalOpen} programId={id}
                      handleClose={() => setDevelopModalOpen(false)}
                      handleConfirm={sendProgramToDevelop}
                      reload={handleReload}
                      isLoading={isUpdatingProgram}
                      modalText="Отправить программу на доработку?"/>
        <ApproveModal open={approveExpertiseModalOpen} programId={id}
                      handleClose={() => setApproveExpertiseModalOpen(false)}
                      handleConfirm={approveProgramExpertise}
                      reload={handleReload}
                      isLoading={isUpdatingProgram}
                      modalText="Одобрить программу?"/>
        <ApproveModal open={rejectExpertiseModalOpen} programId={id}
                      handleClose={() => setRejectExpertiseModalOpen(false)}
                      handleConfirm={rejectProgramExpertise}
                      reload={handleReload}
                      isLoading={isUpdatingProgram}
                      message="После отклонения программа будет снята с экспертизы. Редактирование будет невозможно."
                      modalText="Отклонить программу?"/>
        <ApproveModal open={publicationModalOpen} programId={id}
                      handleClose={() => setPublicationModalOpen(false)}
                      handleConfirm={sendProgramToPublication}
                      reload={handleReload}
                      isLoading={isUpdatingProgram}
                      modalText="Отправить программу на публикацию?"/>
        <ApproveModal open={approvePublicationModalOpen} programId={id}
                      handleClose={() => setApprovePublicationModalOpen(false)}
                      handleConfirm={approveProgramPublication}
                      reload={handleReload}
                      isLoading={isUpdatingProgram}
                      message="После публикации программа будет опубликована в каталоге программ."
                      modalText="Опубликовать программу?"/>
        <ApproveModal open={rejectPublicationModalOpen} programId={id}
                      handleClose={() => setRejectPublicationModalOpen(false)}
                      handleConfirm={rejectProgramPublication}
                      reload={handleReload}
                      isLoading={isUpdatingProgram}
                      modalText="Отклонить публикацию программы?"/>
        <div className={classes.pageRoot}>
          <div className={classes.topBar}>
            <TopBar
              reload={() => getFullProgram(id)}
              returnBack={returnBack}
              disabled={false}
              isUpdating={isUpdatingProgram}
              update={saveProgramHandler}
              created={programFullInfo.info.created}
              status={programFullInfo.info.statusId}
              sendToExpertise={()=>setExpertiseModalOpen(true)}
              sendToDevelop={()=>setDevelopModalOpen(true)}
              sendToPublication={()=>setPublicationModalOpen(true)}
              approveExpertise={()=>setApproveExpertiseModalOpen(true)}
              rejectExpertise={()=>setRejectExpertiseModalOpen(true)}
              approvePublication={()=>setApprovePublicationModalOpen(true)}
              rejectPublication={()=>setRejectPublicationModalOpen(true)}
            />
          </div>
          <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
            <Box noMargin>
              {programFullInfo.info.statusId !== 1 &&
              <Alert style={{marginBottom: "16px"}} severity="info">
                {
                  (programFullInfo.info.statusId === 2 || programFullInfo.info.statusId === 3)
                    ? "Редактирование невозможно. Программа находится на экспертизе."
                    : (
                      programFullInfo.info.statusId === 4
                        ? "Редактирование невозможно. Программа отклонена."
                        : (
                          programFullInfo.info.statusId === 5
                            ? "Редактирование невозможно. Программа находится на публикации."
                            : "Редактирование невозможно. Программа опубликована."
                        )
                    )
                }
              </Alert>}
              <ProgramMainInfoEdit getFullProgram={getFullProgram}
                                   disabled={false || programFullInfo.info.statusId != 1}
                                   programId={id}
                                   programInfo={programFullInfo.info}
                                   programData={programFullInfo.data}
                                   onFormChange={changeProgramInfoAction}/>
            </Box>
            <Box noMargin>
              <ProgramModulesEdit programId={id} disabled={false}/>
            </Box>
            <Box noMargin>
              <ProgramFiles programId={id} disabled={false}
                            programFile={programFullInfo.programFile}
                            certificateFile={programFullInfo.certificateFile}
                            programLogo={programInfo.logo}/>
            </Box>
            {/*<Box noMargin>
              <Authors programId={id}/>
            </Box>
            <Box noMargin>
              <CatalogPreview programInfo={programFullInfo.info}
                               programData={programFullInfo.data}
                               programCatalog={programFullInfo.catalog}
                               programFile={programFullInfo.programFile}
              />
            </Box>*/}
          </Tabs>
        </div>
        {isLarge &&
        <ProgramInfoDrawer programId={id} open hideLink />}
      </div> )
        : (
          <Progress />
        )}
    </div>
  )
};

const mapDispatchToProps = dispatch => ({
  getProgram: (id) => dispatch(getProgram(id)),
  getFullProgram: (id) => dispatch(getFullProgram(id)),
  changeProgramInfoAction: (data) => dispatch(changeProgramInfoAction(data)),
  clearProgramCreatedAction: () => dispatch(clearProgramCreatedAction()),
  updateConstructorProgram: (id, data) => dispatch(updateConstructorProgram(id, data)),
  sendProgramToExpertise: (id, comment) => dispatch(sendProgramToExpertise(id, comment)),
  sendProgramToPublication: (id, comment) => dispatch(sendProgramToPublication(id, comment)),
  sendProgramToDevelop: (id, comment) => dispatch(sendProgramToDevelop(id, comment)),
  approveProgramExpertise: (id, comment) => dispatch(approveProgramExpertise(id, comment)),
  approveProgramPublication: (id, comment) => dispatch(approveProgramPublication(id, comment)),
  rejectProgramExpertise: (id, comment) => dispatch(rejectProgramExpertise(id, comment)),
  rejectProgramPublication: (id, comment) => dispatch(rejectProgramPublication(id, comment)),
});

const mapStateToProps = state => ({
  programInfo: state.programConstruct.programInfo,
  programFullInfo: state.programs.programFullInfo,
  isUpdatingProgram: state.programConstruct.isUpdatingProgram,
  updatedProgram: state.programConstruct.updatedProgram
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProgramEdit));
